const REVEAL_DURATION_MS = 200;
const REVEAL_OFFSET_PX = 4;
export const prefersReducedMotion = () => { var _a, _b; return (_b = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-reduced-motion: reduce)').matches) !== null && _b !== void 0 ? _b : false; };
// Opacity and transform run on the compositor, so this stays cheap even for many elements.
// No fill mode: once finished, the element has no leftover transform.
export const revealElement = (element) => {
    var _a;
    // An element with `display: contents` has no box of its own, so animate its children instead.
    if (window.getComputedStyle(element).display === 'contents') {
        Array.from(element.children).forEach(revealElement);
        return;
    }
    (_a = element.animate) === null || _a === void 0 ? void 0 : _a.call(element, [
        { opacity: 0, transform: `translateY(${REVEAL_OFFSET_PX}px)` },
        { opacity: 1, transform: 'none' },
    ], { duration: REVEAL_DURATION_MS, easing: 'ease-out' });
};
